export default "__VITE_ASSET__Bo8vO5WX__"